export enum LOGISTICS_TYPE {
  /**仓储服务商物流产品*/
  PROVIDER = 'provider',
  /**上游平台自身串接物流*/
  PLATFORM = 'platform',
  /** OMS串接物流 */
  OMS = 'oms',
  /** 自定义物流 */
  CUSTOM = 'custom',
}

/**物流类型 */
export type LogisticsType = 'provider' | 'platform' | 'oms' | 'custom'
